import { currentSlotAtom } from "@/atoms/pools"
import { connectionAtom } from "@/atoms/settings"
import { useAtom } from "jotai"
import { useCallback, useEffect, useRef } from "react"

const INTERVAL_RELOAD_CURRENT_SLOT = 10000

export const useCurrentSlot = () => {
  const [currentSlot, setCurrentSlot] = useAtom(currentSlotAtom)
  const [connection] = useAtom(connectionAtom)
  const intervalRef = useRef<NodeJS.Timeout | null>(null)

  const fetchCurrentSlot = useCallback(async () => {
    try {
      const slot = await connection.getSlot("confirmed")
      setCurrentSlot(slot)
    } catch (error) {
      console.error("Error fetching current slot:", error)
    }
  }, [connection, setCurrentSlot])

  useEffect(() => {
    fetchCurrentSlot()

    intervalRef.current = setInterval(fetchCurrentSlot, INTERVAL_RELOAD_CURRENT_SLOT)

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
      }
    }
  }, [fetchCurrentSlot])

  return { currentSlot, refreshCurrentSlot: fetchCurrentSlot }
}
